export default "__VITE_ASSET__CvozfiLe__"